module.exports = __webpack_public_path__ + "static/media/Ponyta_gaussian2.21fd4137.png";